import * as React from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { OLAF, FLINT } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import PricingPageRedirectWrapper from 'automation-ui-canvas/components/modals/PricingPageRedirectWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ARR_POSITION_TO_CONFIG = [{
  icon: 'deals',
  langKey: 'automation.embed.emptyStates.ecomm.newCustomer'
}, {
  icon: 'cart',
  langKey: 'automation.embed.emptyStates.ecomm.abandonedCart'
}, {
  icon: 'bubble',
  langKey: 'automation.embed.emptyStates.ecomm.reEngagement'
}];
const EcommEmptyState = ({
  arrPosition,
  config,
  disabled,
  disabledMessage,
  lockType,
  onNewFlowButtonClicked
}) => {
  const StyledButton = config ? PricingPageRedirectWrapper : UIButton;
  const extraProps = config ? {
    uniqueId: `create-flow-cta-${arrPosition}`,
    config,
    screen: 'embedded-workflow-create-empty-state'
  } : {};
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    justify: "start",
    direction: "column",
    className: "p-x-3",
    children: [/*#__PURE__*/_jsx(UIIconCircle, {
      name: ARR_POSITION_TO_CONFIG[arrPosition].icon,
      color: OLAF,
      backgroundColor: FLINT,
      borderWidth: 0,
      size: 20
    }), /*#__PURE__*/_jsx("strong", {
      className: "m-y-3",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${ARR_POSITION_TO_CONFIG[arrPosition].langKey}.title`
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "text-center",
      style: {
        minHeight: 75
      },
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${ARR_POSITION_TO_CONFIG[arrPosition].langKey}.description`
      })
    }), /*#__PURE__*/_jsx(UITooltip, {
      title: disabledMessage,
      disabled: !disabled,
      children: /*#__PURE__*/_jsxs(StyledButton, Object.assign({
        use: "tertiary-light",
        onClick: onNewFlowButtonClicked,
        className: "m-y-4",
        disabled: disabled
      }, extraProps, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `${ARR_POSITION_TO_CONFIG[arrPosition].langKey}.button`
        }), !!lockType && /*#__PURE__*/_jsx(UIIcon, {
          name: "locked"
        })]
      }))
    })]
  });
};
export default EcommEmptyState;